import { render, staticRenderFns } from "./InformasiBongkarDetail.vue?vue&type=template&id=482a5f02&scoped=true"
import script from "./InformasiBongkarDetail.vue?vue&type=script&lang=js"
export * from "./InformasiBongkarDetail.vue?vue&type=script&lang=js"
import style0 from "./InformasiBongkarDetail.vue?vue&type=style&index=0&id=482a5f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a5f02",
  null
  
)

export default component.exports